export const appContainer = document.querySelector("app-container");
